import React from "react";
import TextTheme from "components/General/Text/TextTheme";
import "./BlockedListContainer.css";
import RoundedButton from "components/General/Form/CustomButton/RoundedButton";
import BlockedUser from "site_media/images/BlockedUser.png"
/*Friend Request methods*/
import * as FriendRequest from "components/Tribe/Friends/FriendRequestMethods"

class BlockedCell extends React.Component {
  


//Refered to function reversedate() in EachActiveProject.js
// time comes in format "2020-10-27T19:21:36.818120Z" and leaves "10-27-2020"
    formatDate(date) {
        //remove all hour-minute-second info
        var dateString = date.split("T");
        var splitString = dateString[0].split("-");
        var newDate = splitString[1] + "/" + splitString[2] + "/" + splitString[0]
        return newDate;
    }

    render() {
        return (
            <div className="blocked_container">
                <div className="blocked_user_card">
                    <div className="blocked_user_card_column_main">

                        <div className="blocked_user_profile_pic">
                            <img src = {BlockedUser} style = {{width:" 70px", height: "70px"}}
                             alt={"white X in a grey circle"}
                            />
                        </div>

                        <div className="blocked_card_detail_rows">

                            <div className="blocked_user_details_username">
                                <TextTheme
                                    message={this.props.userName}
                                    className={"text_medium text_bold text_dark_blue"}
                                />
                            </div>
                            <div className="blocked_user_details_date">
                                <TextTheme
                                    message={this.props.datePrefix + this.formatDate(this.props.date)}
                                    className={"text_xsmall text_med_grey"}
                                />
                            </div>
                            <div className="unblock_action_button">
                                <RoundedButton
                                    margin="0"
                                    title={this.props.buttonTitle}
                                    textThemeClassName="text_xsmall text_white text_bold"
                                    buttonClassName="background_dark_orange"
                                    handleOnClick={()=>(FriendRequest.unblock(this.props.blockID))}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default BlockedCell;
